import { Paperclip } from 'lucide-react';

import { cn } from '@/lib/utils';

interface BadgeDocumentoNovoProps {
  tamanho?: 'sm' | 'md';
  className?: string;
}

/**
 * Sinal de que a UBS anexou documento e a Regulação ainda não abriu.
 *
 * Tem a mesma forma dos badges de status porque disputa a mesma atenção na
 * fila: numa lista longa, o olho procura a etiqueta arredondada e colorida.
 * O texto acompanha o clipe — a cor sozinha não comunica a quem não a enxerga
 * (WCAG 1.4.1), e o ícone sozinho não diz o que aconteceu.
 */
export function BadgeDocumentoNovo({ tamanho = 'md', className }: BadgeDocumentoNovoProps) {
  const descricao = 'A UBS anexou documento que a Regulação ainda não abriu.';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        'border-status-pendencia-borda bg-status-pendencia-fundo text-status-pendencia-texto',
        tamanho === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className,
      )}
      title={descricao}
    >
      <Paperclip
        className={tamanho === 'sm' ? 'size-3' : 'size-3.5'}
        aria-hidden="true"
        strokeWidth={2.25}
      />
      <span>Documentação anexada</span>
      <span className="apenas-leitor-tela">. {descricao}</span>
    </span>
  );
}
